import { configUK } from './configUK';
import { configAU } from './configAU';
import { configGB } from './configGB';

const GAE_REGION = process.env.REACT_APP_GAE_REGION;

export const config = {
  ...(GAE_REGION === 'gb' ? configUK : GAE_REGION === 'au' ? configAU : configGB)
};
